import React from "react";

import { OneRow } from "../../core/layouts";
import QuestionnaireListingContainer from "../../containers/QuestionnaireListingContainer";

export default function QuestionnaireListingView() {
  return <OneRow section={<QuestionnaireListingContainer />} />;
}
